import {
  BorderRadius4,
  GreyGrey90,
  Primary14SemiBold,
  TextOverflow,
  Center,
  Box,
  Flex
} from '@sequencehq/core-components'
import { InvoiceReviewCustomerLogo } from '../InvoiceReviewCustomerLogo'

/**
 * Modal title bar for the invoice-update review: the customer logo and the title,
 * e.g. "Ramp: Update invoice INV-0018".
 */
export const InvoiceUpdateReviewHeader = ({
  customerId,
  title
}: {
  customerId: string
  title: string
}) => (
  <Flex alignItems="center" gap="8px" overflow="hidden">
    <Center
      borderRadius={BorderRadius4}
      overflow="hidden"
      boxSize="24px"
      flexShrink={0}
    >
      <InvoiceReviewCustomerLogo
        customerId={customerId}
        data-testid="invoiceUpdateReview.header.logo"
      />
    </Center>
    {/* `TextOverflow` owns the truncation + tooltip-on-overflow; the Box carries
        the typography/colour it inherits, and `minWidth={0}` lets it shrink
        within the flex row so long titles ellipsize rather than push the row. */}
    <Box
      {...Primary14SemiBold}
      color={GreyGrey90}
      flex="1"
      minWidth={0}
      data-testid="invoiceUpdateReview.header.title"
    >
      <TextOverflow>{title}</TextOverflow>
    </Box>
  </Flex>
)
